export const MuiAlertTitle = () => ({
  styleOverrides: {
    root: {
      fontFamily: 'gelica, sans-serif'
    }
  }
})
